import React from 'react';

export default function TeamIntro({ icon, title, text }) {
    return <>
    <embed className="team-intro__icon" src={icon} />
        <h2 className="team-intro__title">{title}</h2>
        <p className="team-intro__text lead" dangerouslySetInnerHTML={{__html: text}}/>
    </>
}